import { SafeImage } from '@/components/common/safe-image';
import type { ContentCommonProps } from '@/components/conversations/conversation-list/message-list-item/message-content/content-common-props';
import { MessageQuote } from '@/components/conversations/conversation-list/message-list-item/message-content/message-quote';
import usePreloadImage from '@/hooks/use-preload-image';
import { useIsDesktop } from '@/hooks/use-user-platform';
import cn from '@/utils/merge-class-names';

export default function ContentEmoticon({ message }: ContentCommonProps) {
  const [url] = message.Message.split('|');
  const isDesktop = useIsDesktop();
  const { src: safeSrc, aspectRatio, dimension } = usePreloadImage(url, { maxWidth: isDesktop ? 0.35 : 0.5 });

  return (
    <div
      className={cn('group-data-receiver:col-start-2 group-data-receiver:me-4 group-data-sender:col-start-1', {
        'max-h-48 chat-bubble group-data-receiver:chat-bubble-plain group-data-sender:chat-bubble-primary flex flex-col items-center':
          Boolean(message.Quote),
      })}>
      {message.Quote && (
        <MessageQuote
          className='py-1.5 px-2 mb-1'
          quote={message.Quote}
        />
      )}

      <SafeImage
        className='relative max-w-75vw desktop:max-w-96 min-h-16 min-w-16'
        style={{
          aspectRatio: aspectRatio || 'auto',
          width: 'auto',
          maxWidth: dimension[0] || '100%',
          maxHeight: dimension[1] || 'auto',
          backgroundColor: 'transparent',
        }}
        src={safeSrc}
        displaySize='fixed'
      />
    </div>
  );
}
